<div class="modal-content" style="height: 500px">
  <div class="modal-header">
    <div class="modal-title h4" id="example-modal-sizes-title-lg">
      <h4>Add Image</h4>
    </div>
  </div>
  <div class="overlay overlay-block cursor-default modal-body">
    <div class="col-md-12 mb-5">
      <mat-button-toggle-group
        [(ngModel)]="selected"
        style="width: inherit"
        (change)="reset()"
      >
        <mat-button-toggle style="width: inherit" [value]="0"
          >Product</mat-button-toggle
        >
        <mat-button-toggle style="width: inherit" [value]="1"
          >Brand - Category
        </mat-button-toggle>
        <mat-button-toggle style="width: inherit" [value]="2"
          >Collection</mat-button-toggle
        >
      </mat-button-toggle-group>
    </div>
    <form class="form form-label-right" [formGroup]="formGroup">
      <!-- Product -->
      <div
        class="col-md-12"
        style="display: flex; gap: 25px"
        *ngIf="selected === 0"
      >
        <div class="form-group mb-5" style="width: 100%">
          <label>Products</label>
          <ng-select
            [items]="productsService.items$ | async"
            bindLabel="name"
            [hideSelected]="true"
            [trackByFn]="trackByFn"
            [minTermLength]="2"
            bindValue="id"
            [loading]="productsService.isLoading$ | async"
            typeToSearchText="Please enter 2 or more characters"
            [typeahead]="productSearchInput$"
            formControlName="productId"
          >
          </ng-select>
        </div>
      </div>

      <!-- Category - brand -->
      <div
        class="col-md-12"
        style="display: flex; gap: 25px"
        *ngIf="selected === 1"
      >
        <div class="form-group" style="width: 100%">
          <label>Category</label>
          <ng-select
            [items]="categoriesService.items$ | async"
            bindLabel="fullName"
            [hideSelected]="true"
            [trackByFn]="trackByFn"
            [minTermLength]="2"
            bindValue="id"
            [loading]="categoriesService.isLoading$ | async"
            typeToSearchText="Please enter 2 or more characters"
            [typeahead]="categorySearchInput$"
            formControlName="categoryId"
            (change)="brandsCategoryFilter($event)"
          >
          </ng-select>
        </div>
        <div class="form-group" style="width: 100%">
          <label>Brand</label>
          <ng-select
            [items]="brandsService.items$ | async"
            bindLabel="nameEn"
            [hideSelected]="true"
            [trackByFn]="trackByFn"
            bindValue="id"
            [minTermLength]="2"
            [loading]="brandsService.isLoading$ | async"
            typeToSearchText="Please enter 2 or more characters"
            [typeahead]="brandSearchInput$"
            formControlName="brandId"
          >
          </ng-select>
        </div>
      </div>
      <!-- Collection -->
      <div
        class="col-md-12"
        style="display: flex; gap: 25px"
        *ngIf="selected === 2"
      >
        <div class="form-group" style="width: 100%">
          <label>Collection</label>
          <ng-select
            [items]="collectionService.items$ | async"
            bindLabel="name"
            [hideSelected]="true"
            [trackByFn]="trackByFn"
            [minTermLength]="2"
            bindValue="id"
            [loading]="collectionService.isLoading$ | async"
            typeToSearchText="Please enter 2 or more characters"
            [typeahead]="collectionSearchInput$"
            formControlName="collectionId"
          >
          </ng-select>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light btn-elevate mr-2"
      (click)="onCancelClicked()"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-primary btn-elevate"
      (click)="onSaveClicked()"
      [disabled]="formGroup.invalid"
    >
      Generate
    </button>
  </div>
</div>
